import { BaseModel } from "../../../../../infrastructure/models/base-model";
import {BETTING_CONTAINER} from "../../../betting-container-consts";
import {BaseNavigationModel} from "../../../../../infrastructure/models/link/base-navigation-model";

export class BettingZoneMenuItemModel extends BaseModel {

  constructor(model, parentId = null, level = 0) {
    super();

    this.id = model.id;
    this.parentId = parentId;
    this.level = level;
    this.icon = model.icon;
    this.label = model.label;
    this.linkLabel = model.linkLabel || model.label;
    this.alt = model.alt;
    this.url = model.url;

    this.items = model.items ? model.items.map((item) => new BettingZoneMenuItemModel(item, this.id, this.level + 1)) : null;
  }

  get hasItems() {
    return this.items && this.items.length > 0;
  }

  get displayLabel() {
    return !this.hasItems ? this.linkLabel : this.label;
  }

  get viewType() {
    if (!this.hasItems) return null;

    return this.level === 0 ? BETTING_CONTAINER.MENU_VIEW_TYPE.page : BETTING_CONTAINER.MENU_VIEW_TYPE.accordion;
  }

  get linkModel() {
    return this.url ? new BaseNavigationModel(this.url, true) : null
  }
}